// extracted by mini-css-extract-plugin
export default {"timezone":"SlotSelectionGrid-module-e2a55da4e7a715141571"};